import { c as _c } from "react/compiler-runtime";
import { useAdvisorsToolbarRightElements } from '@src/components/sco/Advisors/layout/AdvisorsToolbarExtras';
import { getAdvisorsToolbarBreadcrumbs } from '@src/components/sco/Advisors/layout/advisorsToolbarBreadcrumbs';
import { AppLayoutToolbar } from '@src/components/sco/AppLayout/Toolbar/AppLayoutToolbar';
import { BreadcrumbItem, useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { useRouter } from 'next/router';
import { useEffect, useMemo } from 'react';
type AdvisorsToolbarProps = {
  breadcrumbs?: BreadcrumbItem[];
  showAside?: boolean;
};
export const AdvisorsToolbar = t0 => {
  const $ = _c(17);
  const {
    breadcrumbs: breadcrumbsProp,
    showAside
  } = t0;
  const router = useRouter();
  const activeContent = useActiveContentContext();
  const rightElements = useAdvisorsToolbarRightElements();
  let t1;
  bb0: {
    if (breadcrumbsProp?.length) {
      t1 = breadcrumbsProp;
      break bb0;
    }
    if (activeContent.breadcrumbs?.length) {
      t1 = activeContent.breadcrumbs;
      break bb0;
    }
    let t2;
    if ($[0] !== router.asPath) {
      t2 = getAdvisorsToolbarBreadcrumbs(router.asPath);
      $[0] = router.asPath;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    t1 = t2;
  }
  const breadcrumbs = t1;
  let t2;
  if ($[2] !== activeContent) {
    t2 = () => {
      activeContent.setSiteSection?.("advisors");
    };
    $[2] = activeContent;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== activeContent.setSiteSection) {
    t3 = [activeContent.setSiteSection];
    $[4] = activeContent.setSiteSection;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== activeContent || $[7] !== showAside) {
    t4 = () => {
      if (showAside) {
        activeContent.setItem?.({
          id: "advisors-aside",
          title: "Advisor"
        });
      } else {
        activeContent.setItem?.(undefined);
      }
      return () => {
        activeContent.setItem?.(undefined);
      };
    };
    $[6] = activeContent;
    $[7] = showAside;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== activeContent.setItem || $[10] !== showAside) {
    t5 = [activeContent.setItem, showAside];
    $[9] = activeContent.setItem;
    $[10] = showAside;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  useEffect(t4, t5);
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      borderBottom: "1px solid {colors.colorPalette.border/25}",
      bgColor: "colorPalette.panel"
    };
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = !showAside;
  let t8;
  if ($[13] !== breadcrumbs || $[14] !== rightElements || $[15] !== t7) {
    t8 = <AppLayoutToolbar boxProps={t6} breadcrumbs={breadcrumbs} hideRightToggleButton={t7} rightElements={rightElements} />;
    $[13] = breadcrumbs;
    $[14] = rightElements;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};